import React from "react"
import ToolTip from "react-portal-tooltip"
interface IProps {
	auditNote: string
	orderKey: string
}
interface IState {
	open: boolean
}

export default class AcceptSuspensePunchResultDetailCol extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	render() {
		return !this.props.auditNote ?
			null :
			(
				<div style={{ width: "100%", height: "100%" }}>
					<ToolTip active={this.state.open} position="left" arrow="center" parent={`#multilple-${this.props.orderKey}`}>
						<div style={{ padding: "5px 10px", width: 400 }}>
							<div>
								{this.props.auditNote}
							</div>
						</div>
					</ToolTip>
					<i
						id={`multilple-${this.props.orderKey}`}
						onMouseOver={() => this.setState({ open: true })}
						onMouseOut={() => this.setState({ open: false })}
						className="fa fa-info-circle"
						style={{ color: "#666666", cursor: "pointer", fontSize: 16, marginTop: 5 }}
					/>
				</div >
			)
	}
}
